// Types du RBAC applicatif (4 rôles figés, hiérarchiques, scopés par compte).
// Les chaînes sont le contrat wire de api-data-platform : ne pas les traduire.

export const APP_ROLES = ['viewer', 'operator', 'editor', 'admin'] as const
export type AppRole = typeof APP_ROLES[number]

export const CAPABILITIES = [
  'read',
  'relay.read',
  'relay.command',
  'fleet.push',
  'planbt.sync',
  'fleet.edit',
  'fleet.pull',
  'planbt.edit',
  'equipment.edit',
  'fleet.delete',
  'planbt.delete',
  'minigrid.delete',
  'users.manage',
] as const
export type Capability = typeof CAPABILITIES[number]

// GET /api/v1/me/app-role — appRole vide = aucun rôle sur le compte actif.
export interface MyAppRoleResponse {
  appRole: AppRole | ''
  capabilities: string[]
}

// role8000 : le rôle 8000 du membre (page « Utilisateurs et Roles ») porte une
// clé Mini-grid ; il prime et ne se modifie pas depuis cette page.
export type AppRoleSource = 'assigned' | 'default' | 'role8000'

export interface AppRoleMember {
  userID: string
  email: string
  name: string
  appRole: AppRole | ''
  source: AppRoleSource
  suspended: boolean
  isAccountAdmin: boolean
}

// GET /api/v1/app-roles
export interface AppRoleMembersResponse {
  accountID: string
  members: AppRoleMember[]
}

export type AppRoleErrorCode =
  | 'forbidden'
  | 'not_member_of_account'
  | 'last_admin'
  | 'busy_retry'
  | 'managed_by_8000_role'
  | 'invalid_role'
  | 'invalid_user'
  | 'rbac_unavailable'
  | 'unauthorized'
  | 'unknown'
